module.exports = __webpack_public_path__ + "static_pc/img/5.1c373d97.png";